import CustomStore from "devextreme/data/custom_store";
import { getLoadOptionsParams } from "../../utils/loadOptionsParams";
import axios from "axios";

const remoteDataSource = (additionalFilter) => {
  return new CustomStore({
    key: "id",
    load: async (loadOptions) => {
      return await axios
        .get(`/api/users/get` + getLoadOptionsParams(loadOptions), {
          params: additionalFilter,
        })
        .then((response) => {
          return {
            data: response.data.data,
            totalCount: response.data.totalCount,
            summary: response.data.summary,
          };
        })
        .catch((error) => {
          let errorMessage =
            error.response && error.response.data
              ? error.response.data
              : error.message;
          throw new Error(errorMessage);
        });
    },
  });
};

export default remoteDataSource;
